import { Container, Stack } from '@mui/material';
import { Helmet } from 'react-helmet-async';

import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PrimaryButton,
  PrimaryOutlinedButton,
} from '../../../../components/style/ButtonStyle';
import {
  CountingText,
  IconLabel,
} from '../../../../components/style/TextStyle';
import { useMapSearchParams, useNaverMap } from '../../../../hooks/useMap';
import useResponsive from '../../../../hooks/useResponsive';
import { SeletedAddressIcon } from '../../../../layouts/dashboard/nav/IconButton';
import markerImg from '../../../static/images/select-marker.png';

export default function SelectAddressPage() {
  const mdUp = useResponsive('up', 'md');
  const initialValue = useMapSearchParams();
  const [selected, setSelected] = useState<any>(initialValue);
  const markerRef = useRef<any>();
  const { setRef } = useNaverMap({
    onMapClick: async function onMapClick(e, map) {
      const lat = e.latlng._lat;
      const lng = e.latlng._lng;
      const position = new window.naver.maps.LatLng(lat, lng);
      const address = await new Promise((resolve, reject) => {
        window.naver.maps.Service.reverseGeocode(
          {
            coords: position,
            orders: 'legalcode,admcode,addr,roadaddr',
          },
          function (status, response) {
            if (status === 200) {
              resolve(response.v2.address);
            } else {
              reject({ status, response });
            }
          },
        );
      });

      onSelect(map, { ...(address || {}), lat, lng } as any);

      function onSelect(map, { jibunAddress, roadAddress, lat, lng }) {
        const position = new window.naver.maps.LatLng(lat, lng);

        if (markerRef.current) {
          markerRef.current.setMap(null);
        }
        const marker = new window.naver.maps.Marker({
          position,
          map,
          icon: {
            content: `<div>
            <img style="width:36px;height:36px;" src="${markerImg}"/>
          </div>
          `,
            size: new window.naver.maps.Size(36, 36),
            // anchor: new window.naver.maps.Point(19, 58),
          },
        });
        markerRef.current = marker;
        setSelected({ jibunAddress, roadAddress, lat, lng });
      }
    },
  });

  return (
    <>
      <Helmet>
        <title> 주소 선택 </title>
      </Helmet>
      <Container maxWidth={false} disableGutters sx={{ height: '100%' }}>
        <Stack direction="row" width="100%" alignItems="stretch" height="100%">
          <Stack
            style={{ width: '100%' }}
            position="relative"
            justifyContent={{ xs: 'flex-end', md: 'auto' }}
            ref={setRef}
          >
            {mdUp ? (
              <DesktopFooter selected={selected} />
            ) : (
              <MobileFooter selected={selected} />
            )}
          </Stack>
        </Stack>
      </Container>
    </>
  );
}

function DesktopFooter({ selected }) {
  const navigate = useNavigate();
  const { lat, lng, zoom } = useMapSearchParams();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        position: 'fixed',
        bottom: '40px',
        left: '15%',
        background: '#fff',
        p: 2,
        width: '70%',
        borderRadius: '30px',
        zIndex: 10,
      }}
    >
      <Stack direction="row" spacing={2}>
        <SeletedAddressIcon />
        <IconLabel>선택된 주소</IconLabel>
        <CountingText>
          {selected?.jibunAddress || '지도에서 주소를 선택해주세요.'}
        </CountingText>
      </Stack>
      <Stack direction="row" spacing={1}>
        <PrimaryOutlinedButton
          sx={{ width: '145px' }}
          onClick={() => navigate(`/map?lat=${lat}&lng=${lng}&zoom=${zoom}`)}
        >
          메인화면으로
        </PrimaryOutlinedButton>
        <PrimaryButton
          sx={{ width: '145px' }}
          onClick={() =>
            navigate(
              `/facility/form?lat=${selected.lat}&lng=${selected.lng}&zoom=15&roadAddress=${selected.roadAddress}&jibunAddress=${selected.jibunAddress}`,
            )
          }
          disabled={!selected?.jibunAddress}
        >
          주소등록
        </PrimaryButton>
      </Stack>
    </Stack>
  );
}

function MobileFooter({ selected }) {
  const navigate = useNavigate();

  const { lat, lng, zoom } = useMapSearchParams();

  return (
    <Stack sx={{ background: '#fff', p: 2.5, zIndex: 10 }} spacing={2}>
      <Stack direction="row" spacing={2}>
        <SeletedAddressIcon />
        <IconLabel>선택된 주소</IconLabel>
      </Stack>
      <CountingText>
        {selected?.jibunAddress || '지도에서 주소를 선택해주세요.'}
      </CountingText>
      <Stack direction="row" spacing={1}>
        <PrimaryOutlinedButton
          onClick={() => navigate(`/map?lat=${lat}&lng=${lng}&zoom=${zoom}`)}
        >
          메인화면으로
        </PrimaryOutlinedButton>
        <PrimaryButton
          onClick={() =>
            navigate(
              `/facility/form?lat=${selected.lat}&lng=${selected.lng}&zoom=15&roadAddress=${selected.roadAddress}&jibunAddress=${selected.jibunAddress}`,
            )
          }
        >
          주소등록
        </PrimaryButton>
      </Stack>
    </Stack>
  );
}
